var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeedometer = function SvgSpeedometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#speedometer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M67.81 74.25C75.328 66.978 80 56.785 80 45.5c0-22.091-17.909-40-40-40S0 23.409 0 45.5c0 11.285 4.673 21.478 12.19 28.75C19.386 67.286 29.192 63 40 63s20.613 4.286 27.81 11.25",
    clipRule: "evenodd",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.922 9.838a2.864 2.864 0 0 1 3.985 4.041L47.65 47.943c-3.229 4.19-9.413 4.567-13.127.8-3.715-3.765-3.253-9.943.98-13.115z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "speedometer_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h80v80H0z"
  })))));
};
export default SvgSpeedometer;